<app-control-layout 
    [control]="formCtrl"
    [label]="label"
    [ignoreLabel]="ignoreLabel"
    [labelBlock]="labelBlock"
    [labelOpacity]="labelOpacity"
    [width]="width"
    [additionalText]="additionalText"
    [maxLength]="maxLength"
    [attr.id] ="idName"
    [shortLengthCount]="shortLengthCount">
    <input type ="textbox" class="form-control text-box" #textInput 
        [formControl]="formCtrl"
        [attr.disabled]="disabled"
        [placeholder]="placeHolder"
        [attr.id] = "idName" 
        [style.width]="labelBlock ? 'calc(100% - 140px)' : width"
        [ngClass]="{'border-danger' : control?.errors?.required && (control?.touched || externalTrigger)}"
        [maxLength]="maxLength"/>
</app-control-layout>
